import { makeStyles } from '@mui/styles';

export const useKioskConnectivityStatusTooltipStyles = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: 'black',
    color: 'white',
    borderRadius: '10px',
    padding: '16px',
    fontSize: '12px',
    fontWeight: 'normal',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '450px'
    }
  },
  tooltipArrow: {
    color: 'black'
  },
  list: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
    '& li:last-child': {
      marginBottom: 0
    }
  },
  listItem: {
    marginBottom: '6px'
  }
}));
